import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiPatch, operationsClient } from '@/lib/api';
import type { Lead, UpdateLeadDto } from '@/types/lead';

export const useUpdateLead = createMutationHook<Lead, UpdateLeadDto>({
  mutationFn: ({ id, ...dto }) =>
    apiPatch<Lead, Omit<UpdateLeadDto, 'id'>>(operationsClient, leadEndpoints.update(id), dto),
  onSuccess: (data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: leadKeys.lists() });
    void queryClient.invalidateQueries({ queryKey: leadKeys.detail(data.id) });
    void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
    toast.success('Lead updated');
  },
});
